module.exports = __webpack_public_path__ + "img/width-medium.f776848.jpg";